import Debug from 'debug'
import { clone, map, find, filter, propEq } from 'ramda'
import addController from './add/add.ctrl'
import addTemplate from './add/add.html'
const debug = Debug('app:crew:controller')

class CrewController {
  /* @ngInject */
  constructor (Crews, Jobs, Users, crews, workforce, $mdDialog, $mdToast, $state, Auth) {
    this.crews = crews
    this.workforce = filter(x => !x.dont_sendor, workforce)
    this.Crews = Crews
    this.Users = Users
    this.Jobs = Jobs
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$state = $state
    this.Auth = this.Auth
    this.tooltips = {
      whatCrew: "A crew is a selection of your favorite workers for a particular job. It's highly recommended to create your crews because choosing the right worker for the right job sets everyone up for success!"
    }
    if (crews.length) this.select(crews[0])
  }

  select (crew) {
    this.selected = clone(crew)
  }

  updateCrewPrompt ($ev, crew) {
    this.selectedCrew = clone(crew)
    this.addCrewModal($ev)
      .then(this.updateCrew.bind(this))
  }

  /**
   * Present modal, deal with modal response.
   */
  addCrewPrompt ($ev) {
    this.selectedCrew = null
    this.addCrewModal($ev)
      .then(this.addCrew.bind(this))
  }

  selectCrewForHire (crew) {
    this.Crews.selectCrew(crew)
    this.$state.go('app.jobCreate', { crewForHire: [crew] })
  }

  transformWorkers (id) {
    const worker = find(propEq('external_id', id), this.workforce)
    if (!worker) return
    return {
      external_id: id,
      first_name: worker.firstName,
      last_name: worker.lastName,
      profile_picture_url: worker.profilePic,
      approval_rating: worker.approvalRating,
      points: worker.points,
      last_shift: worker.lastShift
    }
  }

  /**
   * Send the request, deal with http response.
   */
  addCrew (data) {
    let newCrew = {}
    newCrew.xhr = data
    newCrew.createdAt = new Date()
    newCrew.users = map(this.transformWorkers.bind(this), data.users)
    this.Crews.addCrew(newCrew)
      .then(this.Crews.fetchCrews)
      .then(x => { this.crews = x })
      .then(this.addCrewSuccess.bind(this), this.addCrewError.bind(this))
  }

  removeCrew () {
    const crewId = this.removeId
    return this.Crews.removeCrew({crewId})
      .then(this.Crews.getCrews)
      .then(x => { this.crews = x })
  }

  updateCrew (data) {
    let newCrew = {}
    newCrew.xhr = data
    newCrew.users = map(this.transformWorkers.bind(this), data.users)

    this.Crews.updateCrew(newCrew)
      .then(this.Crews.getCrews)
      .then(x => { this.crews = x })
      .then(this.addCrewSuccess.bind(this), this.addCrewError.bind(this))
  }

  addCrewSuccess () {
    this.$mdToast.showSimple('Group saved!')
    if (this.crews.length === 1) this.select(this.crews[0])
  }

  addCrewError (err) {
    debug(err)
    this.$mdToast.showSimple('Unable to add crew.')
    if (this.crews.length === 1) this.select(this.crews[0])
  }

  addCrewModal ($ev) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: addTemplate,
      targetEvent: $ev,
      locals: {
        workforce: this.workforce,
        crew: this.selectedCrew
      },
      fullscreen: true,
      controller: addController,
      controllerAs: 'add'
    })
  }

  removeSuccess () {
    this.select(this.crews[0])
    this.$mdToast.showSimple('Crew removed!')
  }

  confirmRemove (crew) {
    this.removeId = crew.id
    this.removePrompt()
      .then(this.removeCrew.bind(this))
      .then(this.removeSuccess.bind(this))
  }

  removePrompt () {
    const confirm = this.$mdDialog.confirm()
      .title('Delete crew')
      .textContent('Are you sure you want to delete this crew?')
      .ariaLabel('Delete crew confirmation')
      .ok('Yes')
      .cancel('No')

    return this.$mdDialog.show(confirm)
  }
}

export default CrewController
